import {
    createStore, Store, Reducer, StoreEnhancer,
} from 'redux';
import { load as loadedSession } from 'middleware/redux-sessionstorage';
import { get } from 'lodash/fp';
import { setup } from 'additiv-services';

// 1. Define Internal Logic Types
const loadStateAndSetupServices = (): any => {
    const loaded = loadedSession({ states: ['auth'] });
    const jwt: string | undefined = get('auth.jwt', loaded);

    if (jwt) {
        setup({
            member_token: `${jwt}`,
            bearerAccessToken: `Bearer ${jwt}`,
            bearerApplicationAccessToken: `Bearer ${jwt}`,
        });
    }

    return loaded;
};

// 2. Define the Store Container Interface
interface StoreContainer {
    mStore: Store;
    store: { reducer: Reducer; enhancer?: StoreEnhancer };
}

const storeObj = {
    mStore: ((preloadedState: any): Store => (
        createStore(
            () => {
                // Initial dummy reducer
            },
            preloadedState,
        )
    ))(loadStateAndSetupServices()),

    set store(params: { reducer: Reducer; enhancer?: StoreEnhancer }) {
        const { reducer, enhancer } = params;

        this.mStore = ((preloadedState: any): Store => (
            createStore(
                reducer,
                preloadedState,
                enhancer,
            )
        ))(loadStateAndSetupServices());
    },

    get store(): Store {
        return this.mStore;
    },
};

// 3. Exported Functions
export const getStore = (): Store => storeObj.store;

export const setStore = (reducer: Reducer, enhancer?: StoreEnhancer): Store => {
    storeObj.store = { reducer, enhancer };

    return storeObj.store;
};
